<template>
  <div @click="fun" class="flex items-center gap-[7px] cursor-pointer">
    <span
      :class="`flex items-center justify-center rounded-full border-[1.5px] ${changeStyle ? 'w-[17px] h-[17px]' : 'w-[25px] h-[25px]'} ${
        toShow ? 'border-primary' : 'border-[#E5E5E5]'
      } `"
    >
      <span
        v-if="toShow"
        :class="`block rounded-full  bg-primary ${changeStyle ? 'w-[7px] h-[7px]' : 'w-[11px] h-[11px]'}`"
      ></span>
    </span>
    <span v-if="title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: ["toShow", "title" , "changeStyle"],
  emit: ["fun"],
  methods: {
    fun() {

      this.$emit("fun");
    },
  },
};
</script>

<style>
</style>